import { Loader } from "@workspace/ui";
import type { ReactNode } from "react";

export interface RemoteLoadingFrameProps {
  embedded?: boolean;
  label: ReactNode;
}

export const RemoteLoadingFrame = ({
  embedded = true,
  label,
}: RemoteLoadingFrameProps) => (
  <div
    data-testid="remote-loading-frame"
    className={
      embedded
        ? "flex h-full min-h-0 min-w-0 flex-1 bg-surface-page"
        : "flex min-h-[100dvh] min-w-0 bg-surface-page"
    }
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <aside
      className="hidden w-64 shrink-0 border-r border-border-subtle bg-surface-primary p-5 lg:block"
      aria-hidden="true"
    >
      <div className="h-5 w-36 rounded bg-surface-tertiary" />
      <div className="mt-8 space-y-4">
        <div className="h-4 w-40 rounded bg-surface-tertiary" />
        <div className="h-4 w-32 rounded bg-surface-tertiary" />
        <div className="h-4 w-44 rounded bg-surface-tertiary" />
      </div>
    </aside>
    <div className="flex min-w-0 flex-1 flex-col p-4 md:p-6 lg:p-8">
      <div className="w-full max-w-5xl" aria-hidden="true">
        <div className="h-7 w-48 max-w-full rounded bg-surface-tertiary" />
        <div className="mt-3 h-4 w-72 max-w-full rounded bg-surface-secondary" />
        <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          <div className="h-28 rounded-lg border border-border-subtle bg-surface-primary" />
          <div className="h-28 rounded-lg border border-border-subtle bg-surface-primary" />
          <div className="hidden h-28 rounded-lg border border-border-subtle bg-surface-primary xl:block" />
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center py-8">
        <div className="flex flex-col items-center gap-3 text-center">
          <Loader size="lg" />
          <span className="text-sm text-content-secondary">{label}</span>
        </div>
      </div>
    </div>
  </div>
);
